import React from 'react';

const icon = () => (
  <span className="svg-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path d="M87 39.498H13a3.5 3.5 0 0 0-3.5 3.494v14.016a3.5 3.5 0 0 0 3.5 3.494h3.02A3.984 3.984 0 0 0 20 64.48h6a3.984 3.984 0 0 0 3.98-3.978h40.04A3.984 3.984 0 0 0 74 64.48h6a3.984 3.984 0 0 0 3.98-3.978H87a3.5 3.5 0 0 0 3.5-3.494V42.992a3.5 3.5 0 0 0-3.5-3.494z" fill="#e6eaed" />
      <circle cx="80" cy="50" r="3" fill="none" stroke="#b1b9bf" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
      <path fill="none" stroke="#b1b9bf" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.96" d="M70.876 50h-6m-6.124 0h-6m-6.122 0h-6" />
    </svg>
  </span>
);

export default icon;
